import styles from "./styles.module.scss";

export default class DeleteRenderer {
    init(params) {
        this.eGui = document.createElement("span");

        let style;
        if (params.context.useClearInventoryButton !== undefined) {
            style = styles.clearButton;
        } else if (params.context.menu === "inventory") {
            style = styles.deleteBtnWhite;
        } else {
            style = styles.deleteBtn;
        }

        this.eGui.innerHTML = `<button class="${styles.btn} ${style}"/>`;
        this.eButton = this.eGui.querySelector(`.${styles.btn}`);
        this.eventListener = function () {
            params.context.deleteRow(params.data.id);
        };
        this.eButton.addEventListener("click", this.eventListener);
    }

    getGui() {
        return this.eGui;
    }

    destroy() {
        // do cleanup, remove event listener from button
        if (this.eButton) {
            // check that the button element exists as destroy() can be called before getGui()
            this.eButton.removeEventListener("click", this.eventListener);
        }
    }
}
